const idEstacioSeleccionada = state => state.estacio.formulari.idEstacioSeleccionada;
export default idEstacioSeleccionada;



// WEBPACK FOOTER //
// ./src/selectors/selector_estacio_formulari_id.js